import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Feature } from "app/bundles/requests/shared/models/feature";
import { CoreService } from "app/core/core.service";
import { StorageService } from "app/shared/services/storage.service";
import * as _ from "lodash-es";
import { Subscription } from "rxjs";
import { RequestListType } from "../shared/enums/request-list-type.enum";
import { IWorkorderOrServiceRequestSummary } from "../shared/models/request";
import {
  IBatchMode,
  RequestInBatchService,
} from "../shared/services/request-in-batch.service";

@Component({
  selector: "app-request-summary-list",
  templateUrl: "./request-summary-list.component.html",
  styleUrls: ["./request-summary-list.component.scss"],
})
export class RequestSummaryListComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  public requests: IWorkorderOrServiceRequestSummary[] = [];
  private subscriptions = new Subscription();
  public batchMode: IBatchMode;

  constructor(
    private storageService: StorageService,
    private coreService: CoreService,
    private cdr: ChangeDetectorRef,
    private requestInBatchService: RequestInBatchService,
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.coreService.updateRequest$.subscribe((res) => {
        if (res) {
          const filters: any = this.storageService.getFilters();
          if (res.length > 0 && filters.listType === RequestListType.BOTH) {
            this.requests = this.getRequestFiltered(res);
          } else {
            this.requests = _.filter(this.storageService.getRequests(), {
              isFiltred: true,
            });
          }
        }
      }),
    );

    this.subscriptions.add(
      this.coreService.scrollToRequest$.subscribe((feature: Feature) => {
        if (feature) {
          this.scrollToRequestSelected1(feature);
        }
      }),
    );

    this.subscriptions.add(
      this.requestInBatchService.batchMode$.subscribe(
        (res) => (this.batchMode = res),
      ),
    );

    this.requests = _.filter(this.storageService.getRequests(), {
      isFiltred: true,
    });
  }

  getRequestFiltered(ids: number[]): IWorkorderOrServiceRequestSummary[] {
    const requests: IWorkorderOrServiceRequestSummary[] =
      this.storageService.getRequests();
    const newRequests: IWorkorderOrServiceRequestSummary[] = _.filter(
      requests,
      (o) => {
        return ids.includes(o.id);
      },
    );
    return newRequests;
  }

  public ngAfterViewInit(): void {
    this.cdr.detectChanges();

    this.restoreTrackedRequestIfRequired();
    this.restorePositionInListIfRequired();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public getTrackedRequestId() {
    return this.storageService.getTrackedRequestId();
  }

  private scrollToRequestSelected(requestId: string): void {
    const elements = document.getElementById(requestId);
    if (elements) {
      elements.scrollIntoView(true);
    }
  }

  private scrollToRequestSelected1(feature: Feature): void {
    if (feature && feature.properties && feature.properties.id) {
      let request: IWorkorderOrServiceRequestSummary = _.find(
        this.requests,
        (o) => {
          return o.id === feature.properties.id;
        },
      );
      if (!request && this.requests && this.requests.length) {
        request = this.requests[0];
      }
      if (request && request.id) {
        setTimeout(() => {
          if (request && request.id) {
            const elements = document.getElementById(request.id.toString());
            if (elements) {
              elements.scrollIntoView(true);
            }
          }
        }, 100);
      }
    }
  }

  public onSelectedRequestChange(event: boolean) {
    if (event) {
      this.cdr.detectChanges();
    }
  }

  private restorePositionInListIfRequired(): void {
    const cursorRequestId: string = this.storageService.getPositionList();
    if (cursorRequestId) {
      this.scrollToRequestSelected(cursorRequestId);
      this.storageService.restorePositionList();
    }
  }

  private restoreTrackedRequestIfRequired(): void {
    const selectedRequestId: string = this.storageService.getTrackedRequestId();
    if (selectedRequestId) {
      this.scrollToRequestSelected(selectedRequestId);
      return;
    }
  }
}
